 /* ===== 
 Solution: Thomas Frankowski
 go ecommerce GmbH
 Datum: 2025
 ===== */


document.addEventListener('DOMContentLoaded', () => {
  /* ===== Mobile-Burger & Sub-Menüs ===== */
  const toggleBtn  = document.querySelector('.custom-header__mobile-toggle');
  const mobileNav  = document.getElementById('CustomHeaderMobileNav');

  if (toggleBtn && mobileNav) {
    toggleBtn.addEventListener('click', () => {
      const open = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', (!open).toString());
      mobileNav.style.display = open ? 'none' : 'block';
      mobileNav.setAttribute('aria-hidden', open.toString());
    });
  }
  document.querySelectorAll('.custom-nav-mobile__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const open   = btn.getAttribute('aria-expanded') === 'true';
      const target = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', (!open).toString());
      if (target) {
        target.style.display = open ? 'none' : 'block';
        target.setAttribute('aria-hidden', open.toString());
      }
    });
  });

  /* ===== Header-Offset & Body-Padding dynamisch setzen ===== */
  const header = document.querySelector('.custom-header');
  // Selektoren der Top-Balken; passe an:
  const topBarsSelectors = ['.rating-bar', '.shipping-bar'];
  // Fasse mehrere Balken zusammen: NodeList aus allen gefundenen Elementen
  const topBars = topBarsSelectors
    .map(sel => Array.from(document.querySelectorAll(sel)))
    .flat();

  function adjustHeaderOffset() {
    if (!header) return;

    // Berechne Gesamthöhe aller Top-Balken
    let annHeight = 0;
    topBars.forEach(el => {
      // Wenn Element noch nicht im DOM (z.B. mobil/desktop-wechs.), versuche erneut zu finden
      if (!document.body.contains(el)) {
        // Falls gebraucht: neu query
        // const found = document.querySelectorAll(sel); ...
      }
      const rect = el.getBoundingClientRect();
      annHeight += rect.height;
      // Stelle sicher, dass Position fixed + top korrekt ist:
      el.style.position = 'fixed';
      // Wir setzten top nacheinander, damit Balken untereinander liegen:
      // z.B. erste bei top:0, zweite bei top: Höhe erste, usw.
      // Dafür merken wir den kumulierten Offset:
      el.style.top = (annHeight - rect.height) + 'px';
      el.style.left = '0';
      el.style.right = '0';
      el.style.width = '100%';
      el.style.zIndex = '1100';
    });

    // Header direkt unterhalb der Gesamthöhe platzieren
    const headerHeight = header.getBoundingClientRect().height;
    header.style.position = 'fixed';
    header.style.top = `${annHeight}px`;
    header.style.left = '0';
    header.style.right = '0';
    header.style.width = '100%';
    header.style.zIndex = '1000';

    // Body padding-top so setzen, dass Inhalt nicht unter Balken/Header verschwindet
    document.body.style.paddingTop = `${annHeight + headerHeight}px`;
  }

  // Initial ausführen
  adjustHeaderOffset();
  // Bei Resize erneut ausführen
  window.addEventListener('resize', adjustHeaderOffset);

  /* ===== Hide/Show beim Scroll ===== */
  if (header) {
    let lastScrollY = window.pageYOffset;
    let ticking     = false;
    const delta     = 10;

    function onScroll() {
      const currentY = window.pageYOffset;

      if (Math.abs(currentY - lastScrollY) < delta) {
        ticking = false;
        return;
      }

      // Berechne Gesamthöhe der Top-Balken erneut (falls sich verändert)
      let annHeight = 0;
      topBars.forEach(el => {
        annHeight += el.getBoundingClientRect().height;
      });
      const headerHeight = header.getBoundingClientRect().height;
      const hideAt = annHeight + headerHeight + 20; // Puffer 20px

      if (currentY > lastScrollY && currentY > hideAt) {
        // Scroll-Down: Header ausblenden
        header.classList.add('custom-header--hidden');
        header.classList.remove('custom-header--visible');
      } else if (currentY < lastScrollY) {
        // Scroll-Up: Header einblenden
        header.classList.remove('custom-header--hidden');
        header.classList.add('custom-header--visible');
      }
      lastScrollY = currentY;
      ticking     = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    });
  }
});
